module.exports = {
    fields: {
        email: "Email",
        password: "Password ",
        userName: 'Username ',
        code: 'Code',
        confirm: 'Confirm',

    },
    validation: {
        "required": '{_field_} cannot be empty',
        "min": '{_field_} can not be less than 6 bits',
        "userName": '{_field_} from 4 to 16 digits (letters, numbers, underscores, minus signs)',
        "confirmed": 'Two inconsistent passwords',
        "code": '{_field_} 6 digits',
        "email":'{_field_} format error',
    }
}

// :name="$t('fields.password')"